import { render, staticRenderFns } from "./polarArea-pie-donut-chart.vue?vue&type=template&id=7b9d1b7a&scoped=true&"
import script from "./polarArea-pie-donut-chart.vue?vue&type=script&lang=js&"
export * from "./polarArea-pie-donut-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9d1b7a",
  null
  
)

export default component.exports